import { apiConfig } from '../api-config';

export interface InsertRegisterParams {
  territoryId: string;
  tokenKey: string;
  name: string;
  status: string;
  car: string;
  document: string;
  city: string;
  nameProducer: string;
}
export interface UploadConstestationDocumentParams {
  tokenKey: string;
  cdTerritory: string;
  nameTerritory: string;
  city: string;
  state: string;
  file: File;
}

export const insertConstestation = async (params: InsertRegisterParams) => {
  return apiConfig
    .post('api/Contestation/create', params)
    .then((resp) => resp.data)
    .catch((err) => ({ hasErros: true, err }));
};

export const UploadConstestationDocument = async (params: UploadConstestationDocumentParams) => {
  const formData = new FormData();
  formData.append('TokenKey', params.tokenKey);
  formData.append('CdTerritory', params.cdTerritory);
  formData.append('NameTerritory', params.nameTerritory);
  formData.append('City', params.city);
  formData.append('State', params.state);
  formData.append('File', params.file);

  return apiConfig
    .post('api/DocumentContestation/insert-document-contestation', formData)
    .then((resp) => resp.data)
    .catch((err) => ({ hasErros: true, err }));
};
